import {
  type CreatedDynamicViewApiArg,
  type CreatedDynamicViewApiResponse,
  restV4Api,
} from '@/api/generated/rest-v4-api';

export const SCHEDULE_VIEW_TAG = 'ScheduleView';

const taggedApi = restV4Api.enhanceEndpoints({
  addTagTypes: [SCHEDULE_VIEW_TAG],
  endpoints: {
    getSchedulesReportsView: { providesTags: [SCHEDULE_VIEW_TAG] },
    detailedCountForView: { providesTags: [SCHEDULE_VIEW_TAG] },
    countProjectedRecordsForView: { providesTags: [SCHEDULE_VIEW_TAG] },
  },
});

// The API takes report filters as a POST that returns a view key; the same body is fetched and cached like a read.
export const scheduleViewApi = taggedApi.injectEndpoints({
  endpoints: (build) => ({
    getScheduleViewKey: build.query<CreatedDynamicViewApiResponse, CreatedDynamicViewApiArg>({
      query: ({ scheduleReportFiltersDto }) => ({
        url: '/v4/schedules/reports/view',
        method: 'POST',
        body: scheduleReportFiltersDto,
      }),
    }),
  }),
});

export const {
  useGetScheduleViewKeyQuery,
  useGetSchedulesReportsViewQuery,
  useDetailedCountForViewQuery,
  useCountProjectedRecordsForViewQuery,
} = scheduleViewApi;
